import { Tool } from '../../types';

const TOOL_LOGOS: Record<string, string> = {
  'gusto': 'https://logo.clearbit.com/gusto.com',
  'bamboohr': 'https://logo.clearbit.com/bamboohr.com',
  'rippling': 'https://logo.clearbit.com/rippling.com',
  'gusto-contractor': 'https://logo.clearbit.com/gusto.com',
  'aws': 'https://logo.clearbit.com/aws.amazon.com',
  'google-cloud': 'https://logo.clearbit.com/cloud.google.com',
  'digitalocean': 'https://logo.clearbit.com/digitalocean.com',
  'gmail': 'https://logo.clearbit.com/gmail.com',
  'outlook': 'https://logo.clearbit.com/outlook.com',
  'protonmail': 'https://logo.clearbit.com/proton.me',
  'jotform': 'https://logo.clearbit.com/jotform.com',
  'typeform': 'https://logo.clearbit.com/typeform.com',
  'docusign': 'https://logo.clearbit.com/docusign.com',
  'hellosign': 'https://logo.clearbit.com/hellosign.com',
  'pandadoc': 'https://logo.clearbit.com/pandadoc.com',
  'ringcentral': 'https://logo.clearbit.com/ringcentral.com',
  'grasshopper': 'https://logo.clearbit.com/grasshopper.com',
  'dialpad': 'https://logo.clearbit.com/dialpad.com',
  'salesforce': 'https://logo.clearbit.com/salesforce.com',
  'pipedrive': 'https://logo.clearbit.com/pipedrive.com',
  'hubspot': 'https://logo.clearbit.com/hubspot.com',
  'obs-studio': 'https://logo.clearbit.com/obsproject.com',
  'streamlabs': 'https://logo.clearbit.com/streamlabs.com',
  'vimeo': 'https://logo.clearbit.com/vimeo.com',
  'figma': 'https://logo.clearbit.com/figma.com',
  'adobe-creative-cloud': 'https://logo.clearbit.com/adobe.com',
  'canva': 'https://logo.clearbit.com/canva.com',
  'teachable': 'https://logo.clearbit.com/teachable.com',
  'thinkific': 'https://logo.clearbit.com/thinkific.com',
  'kajabi': 'https://logo.clearbit.com/kajabi.com',
  'stripe': 'https://logo.clearbit.com/stripe.com',
  'square': 'https://logo.clearbit.com/squareup.com',
  'paypal': 'https://logo.clearbit.com/paypal.com',
  'lastpass': 'https://logo.clearbit.com/lastpass.com',
  '1password': 'https://logo.clearbit.com/1password.com',
  'google-analytics': 'https://logo.clearbit.com/google.com',
  'mixpanel': 'https://logo.clearbit.com/mixpanel.com',
  'amplitude': 'https://logo.clearbit.com/amplitude.com',
  'hotjar': 'https://logo.clearbit.com/hotjar.com',
  'shopify': 'https://logo.clearbit.com/shopify.com',
  'woocommerce': 'https://logo.clearbit.com/woocommerce.com',
  'bonsai': 'https://logo.clearbit.com/hellobonsai.com',
  'dubsado': 'https://logo.clearbit.com/dubsado.com',
  'semrush': 'https://logo.clearbit.com/semrush.com',
  'ahrefs': 'https://logo.clearbit.com/ahrefs.com',
  'convertkit': 'https://logo.clearbit.com/convertkit.com',
  'go-high-level': 'https://logo.clearbit.com/gohighlevel.com',
  'click-funnels': 'https://logo.clearbit.com/clickfunnels.com',
  'mailchimp': 'https://logo.clearbit.com/mailchimp.com',
  'active-campaign': 'https://logo.clearbit.com/activecampaign.com',
  'quickbooks': 'https://logo.clearbit.com/quickbooks.intuit.com',
  'freshbooks': 'https://logo.clearbit.com/freshbooks.com',
  'xero': 'https://logo.clearbit.com/xero.com',
  'zapier': 'https://logo.clearbit.com/zapier.com',
  'make': 'https://logo.clearbit.com/make.com',
  'n8n': 'https://logo.clearbit.com/n8n.io',
  'calendly': 'https://logo.clearbit.com/calendly.com',
  'acuity': 'https://logo.clearbit.com/acuityscheduling.com',
  'youcanbook-me': 'https://logo.clearbit.com/youcanbook.me',
  'github': 'https://logo.clearbit.com/github.com',
  'gitlab': 'https://logo.clearbit.com/gitlab.com',
  'vs-code': 'https://logo.clearbit.com/visualstudio.com',
  'buffer': 'https://logo.clearbit.com/buffer.com',
  'hootsuite': 'https://logo.clearbit.com/hootsuite.com',
  'later': 'https://logo.clearbit.com/later.com',
  'jobber': 'https://logo.clearbit.com/getjobber.com',
  'servicetitan': 'https://logo.clearbit.com/servicetitan.com',
  'toggl': 'https://logo.clearbit.com/toggl.com',
  'rescuetime': 'https://logo.clearbit.com/rescuetime.com',
  'harvest': 'https://logo.clearbit.com/getharvest.com',
  'notion': 'https://logo.clearbit.com/notion.so',
  'confluence': 'https://logo.clearbit.com/atlassian.com',
  'clickup': 'https://logo.clearbit.com/clickup.com',
  'miro': 'https://logo.clearbit.com/miro.com',
  'slack': 'https://logo.clearbit.com/slack.com',
  'discord': 'https://logo.clearbit.com/discord.com',
  'zoom': 'https://logo.clearbit.com/zoom.us',
  'intercom': 'https://logo.clearbit.com/intercom.com',
  'drift': 'https://logo.clearbit.com/drift.com',
  'zendesk': 'https://logo.clearbit.com/zendesk.com',
  'freshdesk': 'https://logo.clearbit.com/freshdesk.com',
  'webflow': 'https://logo.clearbit.com/webflow.com',
  'wix': 'https://logo.clearbit.com/wix.com',
  'wordpress': 'https://logo.clearbit.com/wordpress.com',
  'trello': 'https://logo.clearbit.com/trello.com',
  'procore': 'https://logo.clearbit.com/procore.com',
  'asana': 'https://logo.clearbit.com/asana.com',
  'monday': 'https://logo.clearbit.com/monday.com',
  'basecamp': 'https://logo.clearbit.com/basecamp.com',
  'jira': 'https://logo.clearbit.com/atlassian.com',
  'servicem8': 'https://logo.clearbit.com/servicem8.com',
  'housecall-pro': 'https://logo.clearbit.com/housecallpro.com',
  'google-workspace': 'https://logo.clearbit.com/workspace.google.com',
  'dropbox': 'https://logo.clearbit.com/dropbox.com',
  'microsoft-365': 'https://logo.clearbit.com/microsoft.com',
  'appfolio': 'https://logo.clearbit.com/appfolio.com',
  'buildium': 'https://logo.clearbit.com/buildium.com',
  'tableau': 'https://logo.clearbit.com/tableau.com',
  'power-bi': 'https://logo.clearbit.com/powerbi.microsoft.com',
  'looker': 'https://logo.clearbit.com/looker.com',
};

const BRAND_COLORS: Record<string, string> = {
  'slack': '4A154B',
  'notion': '000000',
  'figma': 'F24E1E',
  'stripe': '635BFF',
  'github': '181717',
  'discord': '5865F2',
  'zoom': '2D8CFF',
  'shopify': '7AB55C',
  'mailchimp': 'FFE01B',
  'hubspot': 'FF7A59',
  'salesforce': '00A1E0',
  'trello': '0052CC',
  'asana': 'F06A6A',
  'monday': 'FF3D57',
  'quickbooks': '2CA01C',
  'freshbooks': '0075DD',
  'xero': '13B5EA',
  'zapier': 'FF4A00',
  'calendly': '006BFF',
  'canva': '00C4CC',
  'dropbox': '0061FF',
  'zendesk': '03363D',
  'intercom': '6AFDEF',
  'jira': '0052CC',
  'confluence': '172B4D',
  'miro': 'FFD02F',
  'webflow': '4353FF',
  'wix': '0C6EFC',
  'wordpress': '21759B',
  'paypal': '00457C',
  'square': '3E4348',
  'hotjar': 'FF3C00',
  'mixpanel': '7856FF',
  'amplitude': '1E61E3',
  'semrush': 'FF622D',
  'ahrefs': 'FF8C00',
  'buffer': '168EEA',
  'hootsuite': '143059',
  'toggl': 'E57CD8',
  'harvest': 'FA5D00',
  'docusign': 'FFCC22',
  'pipedrive': '1A1A1A',
  'clickup': '7B68EE',
  'gusto': 'F45D48',
  'bamboohr': '73C41D',
  'rippling': '1A1A1A',
  'aws': 'FF9900',
  'google-cloud': '4285F4',
  'digitalocean': '0080FF',
  'gmail': 'EA4335',
  'outlook': '0078D4',
  'protonmail': '6D4AFF',
  'jotform': 'FF6100',
  'typeform': '262627',
  'pandadoc': '5DBE4A',
  'ringcentral': 'FF8800',
  'grasshopper': '3EB649',
  'dialpad': '7C52FF',
  'vimeo': '1AB7EA',
  'adobe-creative-cloud': 'FF0000',
  'teachable': '73CA4B',
  'thinkific': '1ABC9C',
  'kajabi': 'FF5A28',
  'lastpass': 'D32D27',
  '1password': '1A8CFF',
  'google-analytics': 'E37400',
  'woocommerce': '96588A',
  'bonsai': '00B289',
  'dubsado': 'FFD600',
  'convertkit': 'FB6970',
  'go-high-level': '0EA5E9',
  'click-funnels': '4B7BEC',
  'active-campaign': '356AE6',
  'make': '7B68EE',
  'n8n': 'EA4B71',
  'acuity': '00A4BD',
  'youcanbook-me': 'FF5722',
  'gitlab': 'FC6D26',
  'vs-code': '007ACC',
  'later': 'F34A7D',
  'jobber': '7FBA00',
  'servicetitan': 'FF6B35',
  'rescuetime': '3F89DE',
  'drift': '0176FF',
  'freshdesk': '00A656',
  'procore': 'F47E20',
  'basecamp': '1D2D35',
  'servicem8': '2F89FC',
  'housecall-pro': '00A1E4',
  'google-workspace': '4285F4',
  'microsoft-365': '0078D4',
  'appfolio': '00B5E2',
  'buildium': '00B2A9',
  'tableau': 'E97627',
  'power-bi': 'F2C811',
  'looker': '4285F4',
  'obs-studio': '302E31',
  'streamlabs': '80F5D2',
};

export function getToolLogoUrl(tool: Tool): string {
  if (tool.id && TOOL_LOGOS[tool.id]) {
    return TOOL_LOGOS[tool.id];
  }

  if (tool.imageUrl) {
    return tool.imageUrl;
  }

  const domain = getDomainFromWebsite(tool.website);
  if (domain) {
    return `https://logo.clearbit.com/${domain}`;
  }

  return getAvatarFallback(tool.name, tool.id);
}

export function getLogoByToolId(toolId: string): string | null {
  return TOOL_LOGOS[toolId] || null;
}

export function getBrandColor(toolId: string): string {
  return BRAND_COLORS[toolId] || '3B82F6';
}

export function handleLogoError(event: React.SyntheticEvent<HTMLImageElement, Event>, toolId?: string): void {
  const img = event.currentTarget;
  const toolName = img.alt.replace(' logo', '');
  img.src = getAvatarFallback(toolName, toolId);
}

function getDomainFromWebsite(website?: string): string | null {
  if (!website) return null;
  try {
    const url = new URL(website);
    return url.hostname.replace('www.', '');
  } catch {
    return website.replace(/^https?:\/\//, '').replace('www.', '').split('/')[0];
  }
}

function getAvatarFallback(name: string, toolId?: string): string {
  const bgColor = toolId && BRAND_COLORS[toolId] ? BRAND_COLORS[toolId] : '3B82F6';
  return `https://placehold.co/128x128/${bgColor}/ffffff?text=${encodeURIComponent(name.charAt(0))}&font=roboto`;
}
